<template>
	<div id="Rodape">
		<b-container>
			<b-row>
				<b-col sm=2 md=3>
					<img loading="lazy" src="https://static.ciclic.com.br/svg/ciclic-logo.svg" width="130" height="25">
				</b-col>
				<b-col sm=3 md=3>
					<nav class="footer__nav">
					<ul class="footer__nav-columns">
						<li class="footer__nav-item"  >
							<span class="footer__nav-title">Nosso Produtos</span>
						</li>
						<li >
							<a id="teste" href= "https://www.ciclic.com.br/previdencia/" class="footer__nav-link">Previdência Privada</a>
						</li>

						<li>
							<a  href= "https://www.ciclic.com.br/seguro-viagem/#/" class="footer__nav-link">Seguro Viagem</a>
						</li>
						<li>
							<a  href= "https://produtos.ciclic.com.br/lp/openinsurance/" class="footer__nav-link">Open Insurance</a>
						</li>
						<li>
							<a  href= "https://ciclic.com.br/app" class="footer__nav-link">App</a>
						</li>
						<li>
							<a  href= "https://produtos.ciclic.com.br/previdencia/empresas/" class="footer__nav-link">Para empresa</a>
						</li>

					</ul>
					</nav>
				</b-col>
				<b-col sm=2 md=2>
					<nav class="footer__nav">
					<ul class="footer__nav-columns">
						<li>Sobre a Ciclic</li>
						<li class="footer__nav-column" >
							<a href="https://www.ciclic.com.br/quem-somos">   Quem somos </a>
						</li>
						<li class="footer__nav-column">
							<a href="https://www.ciclic.com.br/faq/seguro-celular">   Dúvidas Frequentes </a>
						</li>
						<li class="footer__nav-column">
							<a href="http://dicas.ciclic.com.br/">   Dicas </a>
						</li>
            <li class="footer__nav-column">
							<a href="https://www.ciclic.com.br/termos-de-uso"> Termos de Uso  </a>
						</li>
					</ul>
					</nav>
				</b-col>
				<b-col sm=2 md=2>
					<nav class="footer__nav">
					<ul class="footer__nav-columns">
						<li class="footer__nav-item">Ajuda</li>
						<li class="footer__nav-item"><a href="javascript:Intercom('show')">Chat</a></li>
						<li class="footer__nav-item">
							<a href="tel:08000244386" class="footer__nav-link" >0800 024 4386</a>
						</li>
						<li class="footer__nav-item">
							<a href="mailto:falecom@ciclic.com.br" class="footer__nav-link" > Fale com a Ciclic</a>
						</li>
					</ul>
					</nav>
				</b-col>
				<b-col sm=3 md=2>
					<ul >
						<li>Redes sociais</li>
					</ul>
					<a href="https://www.facebook.com/CiclicBR">
                        <img loading="lazy" width="32" height="27" src="../../assets/svg/facebook.svg"  alt="facebook">
                    </a>
					<a href="https://twitter.com/CiclicBR">
                       <img loading="lazy" width="48" height="22" src="../../assets/svg/twitter.svg" alt="twitter">
                    </a>
					<a href="https://www.instagram.com/CiclicBR/">
                      <img loading="lazy" width="46" height="26" src="../../assets/svg/instagram.svg" alt="instagram">
                    </a>
				</b-col>
			</b-row>
		</b-container>

    <b-row class="final">
			<b-container>
				<p>
					Ciclic S.A. - CNPJ 29.032.677/0001-93 - Rua Alexandre Dumas, 1671 - 3º Andar - Chácara Santo Antônio, São Paulo - SP, 04717-004, Brasil
          <br>© {{ currentYear }} CICLIC. Todos os direitos reservados.
					<strong>
						<a href="https://ciclic.com.br/termos-de-uso">Termos de uso </a>
					</strong>
				</p>
			</b-container>
		</b-row>
	</div>
</template>

<script>
	import './Rodape.css'
	export default {
		name: 'Rodape',
    computed: {
      currentYear () {
        return new Date().getFullYear()
      }
    }
	}
</script>
